//import React from 'react';
import { get, BASE_URL } from '../client'; // 위에서 만든 apiClient.js 파일 가져오기
//import {DailylookDetail} from '../model/dailylook_detail';

// BASE_URL은 프로젝트 환경에 따라 설정
// const BASE_URL = 'http://52.79.160.172:8001'; 

export const getAlertRead = async (id) => {



  try {
    const responseBody = await get(BASE_URL, '/v1/notifications/' + id);



            console.log(responseBody)
            return responseBody


  } catch (error) {
    console.error('Login failed:', error.message);
    // 에러에 따른 사용자 알림 표시 등
  }
};